<div class="dropdown" *ngIf="gatePass">
   <a  class="nav-link dropdown-toggle"  href="#" role="button"  data-bs-toggle="dropdown" aria-expanded="false" id="dropdownMenuGuardianTools">
        <div class="d-none d-md-block"> <i class='fa fa-angellist'></i></div>
        <i class='fa fa-angellist d-md-none'></i>
        Services and Prices
        <span class="caret"></span>
    </a>

    <div class="dropdown-menu" role="menu" aria-labelledby="dropdownMenuGuardianTools">


    <a *ngIf="gatePass.is_role_guardian" [routerLink]="['static/display/service/offering']" class="nav-link dropdown-item"><i class='fa fa-thumbs-o-up'></i> Services</a>
    <a *ngIf="gatePass.is_role_guardian" [routerLink]="['info/access/plans']" class="nav-link dropdown-item"><i class='fa fa-cart-plus'></i> Pricing</a>
    <a *ngIf="gatePass.is_role_guardian" [routerLink]="['/student/messaging/home',gatePass.user_id]"  class="nav-link nav-main-white dropdown-item"><i class="fa fa-envelope-o"> </i> Messaging </a>
    <a *ngIf="gatePass.is_role_admin" [routerLink]="['home/admin/show']"  class="nav-link dropdown-item"><i class ="fa fa-rocket"></i>Admin</a>
    <a *ngIf="(gatePass.is_member_of_marketing || gatePass.is_member_of_admin)" [routerLink]="['analytics/index']"  class="nav-link dropdown-item"> <i class ="fa fa-line-chart"></i> Analytics</a>
    </div>
    </div>
